/**
 * 项目管理
 * **/

const projectApi = {
  //获取列表
  getList: '/Project/GetList',
  //获取信息
  getInfo: '/Project/GetInfo',
  //添加
  add: '/Project/Add',
  //修改
  edit: '/Project/Edit',
  //删除
  delete: '/Project/Del',
  // 用户列表
  usergetList:'/SysUserProjects/GetList',
  //用户列表删除
  userDel:'/SysUserProjects/Del'

}

export default projectApi
